<app-layout>
  @if (isLoading()) {
    <app-loading />
  } @else if (inviteOnly()) {
    <div class="invite-only">
      <i class="pi pi-lock invite-only__icon" aria-hidden="true"></i>
      <h2 class="invite-only__title">Este evento é exclusivo para convidados</h2>
      @if (isUserLoggedIn) {
        <p class="invite-only__text">
          O e-mail da sua conta não está na lista de convidados deste evento. Caso acredite que isso é um engano, entre
          em contato com o organizador.
        </p>
      } @else {
        <p class="invite-only__text">Faça login com a conta que recebeu o convite para acessar este evento.</p>
        <button type="button" class="invite-only__button" (click)="openLogin()">Fazer login</button>
      }
    </div>
  } @else {
    @if (appContinuation(); as continuation) {
      <aside class="app-continuation" aria-label="Continuar no aplicativo Yes7 Tickets">
        <img
          class="app-continuation__logo"
          src="assets/images/yes7-logo-icone.png"
          alt=""
          width="48"
          height="48" />
        <div class="app-continuation__copy">
          <strong>Continue este evento no aplicativo</strong>
          <span>{{ continuation.description }}</span>
        </div>
        <div class="app-continuation__actions">
          <a class="app-continuation__button" [href]="continuation.url">
            {{ continuation.label }}
          </a>
          <a class="app-continuation__button app-continuation__button--secondary" [href]="continuation.openUrl">
            Abrir evento no app
          </a>
        </div>
      </aside>
    }
    <app-event-details
      [currentBatch]="currentBatch$ | async"
      [isBatchLoading]="isBatchLoading()"
      [eventInfo]="eventInfo$ | async"
      [eventMapCenterLocation]="eventMapCenterLocation$ | async"
      [spaceIdsInCart]="spaceIdsInCart()"
      [loadingSpaceIds]="loadingSpaceIds()"
      [isCheckoutInProgress]="isCheckoutInProgress()"
      [pendingCouponCode]="pendingCouponCode()"
      (favoriteButtonClick)="handleFavoriteToggle()"
      (checkoutClick)="handleCheckoutClick($event)"
      (addSpaceClick)="handleAddSpaceClick($event)"
      (removeSpaceClick)="handleRemoveSpaceClick($event)" />
  }
</app-layout>
